import { DEFAULT_LANG } from "./constant/constant"

export const getCurrentLanguageFromURL = () => {
	
	const isBrowser = typeof window !== "undefined";
	
	if(isBrowser) {
		const localStorageKey = 'gatsby-i18next-language';
		const storedLanguage = window.localStorage.getItem(localStorageKey);
		if(!storedLanguage) {
			window.localStorage.setItem(localStorageKey, DEFAULT_LANG);
			return DEFAULT_LANG;
		}
		return storedLanguage;
	}
	
	return DEFAULT_LANG;
};

export const isMobile = () => {
	
	const isBrowser = typeof window !== "undefined"
	if(isBrowser) {
		return window.innerWidth < 640;
	}
	
	return true;
	
	// return /Mobi|Android/i.test(window.navigator.userAgent);
}